"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesLayer = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const GameState_1 = require("../../Core/GameState");
const SymbolClasses_1 = require("../../Utils/SymbolClasses");
const SlideBarSprite_1 = require("../Components/SlideBarSprite");
const SimLineSprite_1 = require("../Components/SimLineSprite");
const SingleNoteSprite_1 = require("../Components/SingleNoteSprite");
const FlickNoteSprite_1 = require("../Components/FlickNoteSprite");
const SlideNoteSprite_1 = require("../Components/SlideNoteSprite");
const SlideAmongSprite_1 = require("../Components/SlideAmongSprite");
const GameConfig_1 = require("../../Core/GameConfig");
const Utils_1 = require("../../Utils/Utils");
let BarLayer = class BarLayer extends pixi_js_1.Container {
    constructor(state, helper, ioc) {
        super();
        this.state = state;
        this.helper = helper;
        this.ioc = ioc;
        this.nextBarIndex = 0;
        this.pool = new Utils_1.ObjectPool();
        this.sortableChildren = true;
        this.pool.newObj = () => {
            const b = this.ioc.resolve(SlideBarSprite_1.SlideBarSprite);
            this.addChild(b);
            return b;
        };
    }
    update(musicTime, showTime) {
        let index = this.nextBarIndex;
        const list = this.state.map.bars;
        while (index < list.length && list[index].start.time < showTime) {
            const bar = this.pool.get();
            bar.applyInfo(list[index]);
            index++;
        }
        this.nextBarIndex = index;
        for (let i = 0; i < this.children.length; i++) {
            const x = this.children[i];
            x.update(musicTime);
            if (x.shouldRemove) {
                x.shouldRemove = false;
                this.pool.save(x);
            }
        }
    }
};
BarLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameState_1.GameState, SymbolClasses_1.NoteHelper, inversify_1.Container])
], BarLayer);
let SimLineLayer = class SimLineLayer extends pixi_js_1.Container {
    constructor(config, state, ioc) {
        super();
        this.config = config;
        this.state = state;
        this.ioc = ioc;
        this.nextSimIndex = 0;
        this.pool = new Utils_1.ObjectPool();
        this.sortableChildren = true;
        this.pool.newObj = () => {
            const s = this.ioc.resolve(SimLineSprite_1.SimLineSprite);
            this.addChild(s);
            return s;
        };
    }
    update(musicTime, showTime) {
        if (this.config.showSimLine) {
            let index = this.nextSimIndex;
            const list = this.state.map.simlines;
            while (index < list.length && list[index].left.time < showTime) {
                const sim = this.pool.get();
                sim.applyInfo(list[index]);
                index++;
            }
            this.nextSimIndex = index;
            for (let i = 0; i < this.children.length; i++) {
                const x = this.children[i];
                x.update(musicTime);
                if (x.shouldRemove) {
                    x.shouldRemove = false;
                    this.pool.save(x);
                }
            }
        }
    }
};
SimLineLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameConfig_1.GameConfig, GameState_1.GameState, inversify_1.Container])
], SimLineLayer);
const spritemap = {
    single: SingleNoteSprite_1.SingleNoteSprite,
    flick: FlickNoteSprite_1.FlickNoteSprite,
    flickend: FlickNoteSprite_1.FlickNoteSprite,
    slidestart: SlideNoteSprite_1.SlideNoteSprite,
    slideend: SlideNoteSprite_1.SlideNoteSprite,
    slideamong: SlideAmongSprite_1.SlideAmongSprite,
};
let NoteLayer = class NoteLayer extends pixi_js_1.Container {
    constructor(state, ioc) {
        super();
        this.state = state;
        this.ioc = ioc;
        this.nextNoteIndex = 0;
        this.pool = {};
        this.sortableChildren = true;
        for (const key in spritemap) {
            this.pool[key] = new Utils_1.ObjectPool();
            this.pool[key].newObj = () => {
                const type = spritemap[key];
                const n = this.ioc.resolve(type);
                this.addChild(n);
                return n;
            };
        }
    }
    update(musicTime, showTime) {
        let index = this.nextNoteIndex;
        const list = this.state.map.notes;
        while (index < list.length && list[index].time < showTime) {
            const info = list[index];
            const note = this.pool[info.type].get();
            note.applyInfo(info);
            index++;
        }
        this.nextNoteIndex = index;
        for (let i = 0; i < this.children.length; i++) {
            const x = this.children[i];
            x.update(musicTime);
            if (x.shouldRemove) {
                x.shouldRemove = false;
                this.pool[x.note.type].save(x);
            }
        }
    }
};
NoteLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameState_1.GameState, inversify_1.Container])
], NoteLayer);
let NotesLayer = class NotesLayer extends pixi_js_1.Container {
    constructor(state, ioc, helper, config) {
        super();
        this.state = state;
        this.helper = helper;
        this.config = config;
        this.update = (remove, musicTime) => {
            if (this.state.ended)
                return remove();
            const time = this.helper.staytime + musicTime.visualTime;
            this.barLayer.update(musicTime.visualTime, time);
            this.simLineLayer.update(musicTime.visualTime, time);
            this.noteLayer.update(musicTime.visualTime, time);
        };
        state.on.musicTimeUpdate.add(this.update);
        this.barLayer = ioc.resolve(BarLayer);
        this.noteLayer = ioc.resolve(NoteLayer);
        this.simLineLayer = ioc.resolve(SimLineLayer);
        this.addChild(this.barLayer);
        this.addChild(this.simLineLayer);
        this.addChild(this.noteLayer);
        this.barLayer.alpha = config.barOpacity;
    }
};
NotesLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameState_1.GameState, inversify_1.Container, SymbolClasses_1.NoteHelper, GameConfig_1.GameConfig])
], NotesLayer);
exports.NotesLayer = NotesLayer;
//# sourceMappingURL=NotesLayer.js.map